import type { JourneyFilters, JourneyStatusFilter } from './filterJourneys.ts';

/** The journey list's filters as they stand in the URL. Left out, a filter is at its default. */
export interface JourneysSearch {
  status?: JourneyStatusFilter;
  type?: string;
}

const STATUS_FILTERS: readonly JourneyStatusFilter[] = [
  'all',
  'action_required',
  'running',
  'done',
  'stopped',
];

/* Opens on what still needs the manager: done and stopped journeys wait until asked for. */
const DEFAULT_STATUS: JourneyStatusFilter = 'running';

/**
 * The list's filters out of the URL. They travel to a journey and back with
 * it, so the way back lands on the list as it was left.
 */
export function journeysSearch(search: Record<string, unknown>): JourneysSearch {
  const status = STATUS_FILTERS.find((filter) => filter === search.status);
  const type =
    typeof search.type === 'string' && search.type !== '' ? search.type : undefined;
  return { status: status === DEFAULT_STATUS ? undefined : status, type };
}

export function journeyFiltersOf(search: JourneysSearch): JourneyFilters {
  return { status: search.status ?? DEFAULT_STATUS, type: search.type ?? '' };
}

export function journeysSearchOf(filters: JourneyFilters): JourneysSearch {
  return journeysSearch({ status: filters.status, type: filters.type });
}
